import React, { useState } from 'react';
import SideActionBoard from '../../../../../components/SideActionBoard';

import AddRepresentative from './AddRepresentative';

const Sidebar = ({ openSideActionBoard, setOpenSideActionBoard, onSuccess }) => {
  const { id } = openSideActionBoard;
  return (
    <SideActionBoard setOpenSideActionBoard={setOpenSideActionBoard}>
      <AddRepresentative
        id={id}
        setOpenSideActionBoard={setOpenSideActionBoard}
        onSuccess={onSuccess}
      />
    </SideActionBoard>
  );
};

export default Sidebar;